/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-model',
    'pip-common.validate',
    'pip-events',
    'thd.recommendations',
    'thd-recommendations-articles',
    'resxclsx',
    'thd-utils',
    'window',
    'mustache'
],
function(
    pip,
    pipValidate,
    pipEvents,
    recommendations,
    articles,
    certonaResx,
    thdUtils,
    window,
    Mustache
){

    var SPONSORED_API_KEY = '2zSR74pj5Rq6zDtHENHkAScT4RWsl0pg';
    var CERTONA_API_KEY = 'tRXWvUBGuAwEzFHScjLw9ktZ0Bw7a335';
    var schemas = {
        recommendations: {
            mobile: {
                customersAlsoBought: 'mobileweb_pip_rr',
                similarItems: 'PIPHorizontal2_rr',
                outOfStock: 'PIPHorizontal3_rr'

            },
            desktop: {
                customersAlsoBought: 'PIPHorizontal1_rr',
                similarItems: 'PIPHorizontal2_rr',
                outOfStock: 'PIPHorizontal3_rr',
            }
        },
        recentlyViewed: {
            mobile: {
                appliance: 'rv_mobileweb_rr',
                merchandise: 'rv_mobileweb_rr'
            },
            desktop: {
                appliance: 'rv_bica_pip_rr',
                merchandise: 'rv_gm_pip_rr'
            }
        },
        dynamicRecs: {
          mobile: {
            pipAlternativeNonHD: 'pip_mobile',
            inStock: 'pip_instock_mobile',
            pipSem: 'pip_sem_mobile',
            visSim: 'visuallysimilar_1_0',
            requiredItems: 'required_items'
          },
          desktop: {
            pipAlternativeNonHD: 'Pip_Alternatives_Non_HDhome',
            inStock: 'pipinstock',
            pipSem: 'pipsem',
            visSim: 'visuallysimilar_1_0',
            requiredItems: 'required_items'
          }
        },
        sponsoredProducts: 'pip_sponsored',
        outOfStockSimilarRecommendations: 'pnf1_rr',
        articles: 'articles_rec'

    };

    var view = {
      selectors: {
        certonaRecentlyViewed: '#certona_recently_viewed',
        criteoSponsoredProducts: '#criteo_sponsored_products',
        certonaReferrerRecommendations: '#certona_referrer_recommendations',
        certonaRecommendations: '#certona_recommendations',
        certonaVisuallySimilar: '#certona_visually_similar'
      },
      templates: {
        certonaRecommenderTemplate: '<div id="{{certonaRecommenderId}}"></div>',
        certonaRecentlyViewedTemplate: '<div id="{{certonaRecentlyViewedId}}"></div>',
        criteoSponsoredProductsTemplate: '<div id="{{sponsoredProducts}}"></div>',
        visSimTemplate: '<div id="{{visuallySimilarId}}"></div>'
      },
      render: {
        certonaRecommender: function renderCertonaRecommender() {
          return Mustache.render(view.templates.certonaRecommenderTemplate, {certonaRecommenderId: viewModel.determineCertonaRecommenderRenderScenario()});
        },
        dynamicRecommender: function renderDynamicRecommender() {
          return Mustache.render(view.templates.certonaRecommenderTemplate, {certonaRecommenderId: viewModel.determineDynamicRecommenderRenderScenario()});
        },
        certonaRecentlyViewed: function renderCertonaRecentlyViewed(pipRecommendations) {
          return Mustache.render(view.templates.certonaRecentlyViewedTemplate, {certonaRecentlyViewedId: viewModel.determineCertonaRecentlyViewedId(pipRecommendations)});
        },
        criteoSponsoredProducts: function renderSponsoredProducts() {
          return Mustache.render(view.templates.criteoSponsoredProductsTemplate, {sponsoredProducts: viewModel.determineSponsoredProducts()});
        },
        outOfStockRecentlyViewed: function renderOutOfStockRecentlyViewed(outOfStockRecommendations) {
          return Mustache.render(view.templates.certonaRecentlyViewedTemplate, {certonaRecentlyViewedId: viewModel.outOfStockCertonaRecentlyViewedId(outOfStockRecommendations)});
        },
        outOfStockCertonaRecommender: function outOfStockCertonaRecommender() {
          return Mustache.render(view.templates.certonaRecommenderTemplate, {certonaRecommenderId: viewModel.determineOutOfStockCertonaRecommenderRenderScenario()});
        },
        visuallySimilarRecommender: function visuallySimilarRecommender() {
          return Mustache.render(view.templates.visSimTemplate, {visuallySimilarId: viewModel.determineVisuallySimilarProducts()});
        }
      },
      updateDOM: {
        certonaRecommenderContainer: function updateCertonaRecommenderContainer() {
          $(viewModel.determineDOMTarget()).html(view.render.certonaRecommender());
        },
        dynamicRecommenderContainer: function updateDynamicRecommenderContainer() {
          $(viewModel.determineDOMTarget()).html(view.render.dynamicRecommender());
        },
        certonaRecentlyViewedContainer: function updateCertonaRecentlyViewedContainer(pipRecommendations) {
          $(view.selectors.certonaRecentlyViewed).html(view.render.certonaRecentlyViewed(pipRecommendations));
        },
        criteoSponsoredProductsContainer: function updateCriteoSponsoredProductsContainer() {
          $(view.selectors.criteoSponsoredProducts).html(view.render.criteoSponsoredProducts());
        },
        outOfStockRecentlyViewedContainer: function updateoutOfStockRecentlyViewedContainer(outOfStockRecommendations) {
          $(view.selectors.certonaRecentlyViewed).html(view.render.outOfStockRecentlyViewed(outOfStockRecommendations));
        },
        outOfStockCertonaRecommenderContainer: function updateOutOfStockCertonaRecommenderContainer() {
          $(viewModel.determineDOMTarget()).html(view.render.outOfStockCertonaRecommender());
        },
        visuallySimilarRecommenderContainer: function visuallySimilarRecommenderContainer() {
          $(view.selectors.certonaVisuallySimilar).html(view.render.visuallySimilarRecommender());
        }
      },
      init: function initView(pipRecommendations) {
        view.updateDOM.certonaRecommenderContainer();
        if(pip.features.dynamicRecsAPIsEnabled){
          view.updateDOM.dynamicRecommenderContainer();
          view.updateDOM.visuallySimilarRecommenderContainer();
        }
        view.updateDOM.certonaRecentlyViewedContainer(pipRecommendations);
        view.updateDOM.criteoSponsoredProductsContainer();
      }
    };
    var viewModel = {
        outOfStockRecommendations: {},
        pipRecommendations: {},
        determineDOMTarget: function determineDOMTarget() {
            return (isFromSearchEngine() || isFromProductListAd(viewModel.pipRecommendations) || isFromPinterest(viewModel.pipRecommendations)) ? view.selectors.certonaReferrerRecommendations : view.selectors.certonaRecommendations;
        },

        outOfStockCertonaRecentlyViewedId: function outOfStockCertonaRecentylViewedId() {
          return schemas.recentlyViewed[viewModel.outOfStockRecommendations.platform][viewModel.outOfStockRecommendations.itemType];
        },

        determineCertonaRecommenderRenderScenario: function determineCertonaRecommenderRenderScenario() {
          if(!pip.features.dynamicRecsAPIsEnabled){
            if (isFromSearchEngine() || isFromProductListAd(viewModel.pipRecommendations) || isFromPinterest(viewModel.pipRecommendations)) {
                return schemas.recommendations[viewModel.pipRecommendations.platform].similarItems;
            }
            if (isUnavailableScenario()){
                return schemas.recommendations[viewModel.pipRecommendations.platform].outOfStock;
            }
            return schemas.recommendations[viewModel.pipRecommendations.platform].customersAlsoBought;
          }
        },
        determineDynamicRecommenderRenderScenario: function determineDynamicRecommenderRenderScenario() {
          if(pip.features.dynamicRecsAPIsEnabled){
            if (isFromSearchEngine() || isFromProductListAd(viewModel.pipRecommendations) || isFromPinterest(viewModel.pipRecommendations)) {
              return schemas.dynamicRecs[viewModel.pipRecommendations.platform].pipSem;
            }
            if (isUnavailableScenario()){
              return schemas.dynamicRecs[viewModel.pipRecommendations.platform].inStock;
            }
            return schemas.dynamicRecs[viewModel.pipRecommendations.platform].pipAlternativeNonHD;
          }
        },

        determineCertonaRecentlyViewedId: function determineCertonaRecentlyViewedId(pipRecommendations) {
            return schemas.recentlyViewed[pipRecommendations.platform][pipRecommendations.itemType];
        },

       determineOutOfStockCertonaRecommenderRenderScenario: function determineOutOfStockCertonaRecommenderRenderScenario() {
          return schemas.outOfStockSimilarRecommendations;
       },
        determineSponsoredProducts: function determineSponsoredProducts() {
            return  schemas.sponsoredProducts;
        },
        determineVisuallySimilarProducts: function determineVisuallySimilarProducts(){
          return schemas.dynamicRecs[viewModel.pipRecommendations.platform].visSim;
        }
    };

    function isFromSearchEngine() {
        var siteList = /google.com|bing.com|yahoo.com|duckduckgo.com|aol.com/i;
        return siteList.test(window.document.referrer);
    }

    function isFromProductListAd(pipRecommendations) {
        return /^Shopping/.test(pipRecommendations.cm_mmcParam);
    }

    function isFromPinterest(pipRecommendations) {
        return /PIN_Shopping/.test(pipRecommendations.cm_mmcParam);
    }

    function isUnavailableScenario() {

        if (pip.products.primary.data.itemAvailability.discontinuedItem) return true;
        if (pip.products.primary.data.itemExtension.browseOnlyItem) return isStoreOutOfStock();
        if (pip.products.primary.data.itemExtension.onlineOnlyItem) return isOnlineOutOfStock();
        if (pip.products.primary.data.itemExtension.sharedItem) return isSharedOutOfStock();
    }

    function isSharedOutOfStock() {

        if (pip.inventory && pip.inventory.store && pip.inventory.online) {

            return !!(pip.inventory.online.isOutOfStock ||
                pip.inventory.online.isBackordered ||
                pip.inventory.online.isUnavailable ||
                pip.inventory.store.isOutOfStock ||
                pip.inventory.store.isLimitedQuantity ||
                pip.inventory.store.isUnavailable);
        }

        return false;
    }

    function isStoreOutOfStock() {

        if (pip.inventory && pip.inventory.store) {

            return !!(pip.inventory.store.isOutOfStock ||
                pip.inventory.store.isLimitedQuantity ||
                pip.inventory.store.isUnavailable);
        }

        return false;
    }

    function isOnlineOutOfStock() {
        if (pip.inventory && pip.inventory.online) {

            return !!(pip.inventory.online.isOutOfStock ||
                pip.inventory.online.isBackordered ||
                pip.inventory.online.isUnavailable);
        }

        return false;
    }

    function shouldDisplayReferrerRecommendations (pipRecommendations) {

        return !!(pip.features.certonaReferrerRecommenderFeature &&
            pip.features.certonaReferrerRecommenderFeature.isFeatureEnabled &&
            (certona.isFromSearchEngine() || certona.isFromProductListAd(pipRecommendations) || certona.isFromPinterest(pipRecommendations)));
    }

    function shouldDisplayOutOfStockRecommendations (pipRecommendations) {
      return !!(certona.isUnavailableScenario());
    }

    function getOutOfStockPlatform() {
      //FrontEndModel does not call the Pip error page
      return navigator.userAgent.match(/iPad/g) || (navigator.userAgent.match(/iPhone|(Android)/g)) ? 'mobile' : 'desktop';
    }

    function outOfStockProducts() {
      //FrontEndModel does not call the Pip error page
        var productInformationLocation = window.location.pathname.split('/');
        var productInformation = productInformationLocation[2];
        return productInformation;
     }

     function shouldDisplayVisuallySimilar() {
      return (pip && pip.products.primary.data.info && pip.products.primary.data.info.recommendationFeatures &&
              pip.products.primary.data.info.recommendationFeatures.indexOf('VIS') > -1 && pip.features.visuallySimilarFeatureEnabled);
    }

    function outOfStockRecsThdSchemas() {
      //FrontEndModel does not call the Pip error page
      var isProductValid = /^\d{9}$/;
      if (outOfStockProducts().match(isProductValid)) {
        viewModel.outOfStockRecommendations.itemType = 'merchandise';
        viewModel.outOfStockRecommendations.platform = getOutOfStockPlatform();

        window.resx = {
          apiKey: CERTONA_API_KEY,
          certonaSchema: [schemas.outOfStockSimilarRecommendations, schemas.recentlyViewed[viewModel.outOfStockRecommendations.platform][viewModel.outOfStockRecommendations.itemType]],
          page: 'PIP',
          storeId: pip.customer.getStoreNumber(),
          products: outOfStockProducts()
        };
        view.updateDOM.outOfStockCertonaRecommenderContainer();
        view.updateDOM.outOfStockRecentlyViewedContainer(viewModel.outOfStockRecommendations.platform, viewModel.outOfStockRecommendations.itemType);
        recommendations.refresh(window.resx);
      }
    }

    function getCertonaSchema(pipRecommendations) {
        // similar items recommendation needs to be the 2nd scheme per Certona rules
        var recommendationsKey;
        var recentlyViewedSchema;
        var recommendationsSchema;
        var articleRecommendationsSchema = "articles_rec";
        var schemaList = [];
        if(!pip.features.dynamicRecsAPIsEnabled){
          if(pipRecommendations.shouldCallReferrerRecs){
              schemaList.push(schemas.recommendations[pipRecommendations.platform]['similarItems']);
          } else {
            recentlyViewedSchema = schemas.recentlyViewed[pipRecommendations.platform][pipRecommendations.itemType];
            schemaList.push(recentlyViewedSchema);
            recommendationsKey = 'customersAlsoBought';
            if(shouldDisplayReferrerRecommendations(pipRecommendations) && pipRecommendations.platform !== 'desktop') {
                recommendationsKey = '';
            } else if (shouldDisplayReferrerRecommendations(pipRecommendations) && pipRecommendations.platform === 'desktop') {
                recommendationsKey = 'similarItems';
            } else if (shouldDisplayOutOfStockRecommendations(pipRecommendations)) {
                recommendationsKey = 'outOfStock';
            }
            recommendationsSchema = schemas.recommendations[pipRecommendations.platform][recommendationsKey];
            if(recommendationsSchema){
              schemaList.push(recommendationsSchema);
            }
          }
        } else {
          recentlyViewedSchema = schemas.recentlyViewed[pipRecommendations.platform][pipRecommendations.itemType];
          schemaList.push(recentlyViewedSchema);
        }
        if (pip.features.recommendedGuidesFeatureEnabled) {
          schemaList.push(articleRecommendationsSchema);
        }
        return schemaList;
    }

    function getDynamicRecsSchema(pipRecommendations) {
      var recommendationsKey;
      var recommendationsSchema;
      var schemaList = [];
      if(pip.features.dynamicRecsAPIsEnabled){
        recommendationsKey = 'pipAlternativeNonHD';
        if( shouldDisplayReferrerRecommendations(pipRecommendations) ){
          recommendationsKey = 'pipSem';
        } else if (shouldDisplayOutOfStockRecommendations(pipRecommendations)) {
          recommendationsKey = 'inStock';
        }
        recommendationsSchema = schemas.dynamicRecs[pipRecommendations.platform][recommendationsKey];
        if(recommendationsSchema){
          schemaList.push(recommendationsSchema);
        }
        if(shouldDisplayVisuallySimilar()){
          schemaList.push(schemas.dynamicRecs[pipRecommendations.platform]['visSim']);
        }
        if (pip.features.dynamicRecsRequiredItemsEnabled) {
          schemaList.push(schemas.dynamicRecs[pipRecommendations.platform]['requiredItems']);
        }
      }
      return schemaList;
    }

    function updateResx() {

        window.resx = {
            event: 'product',
            itemid: pip.products.primary.data.itemId.toString()
        };
    }

    function refreshContent(pipRecommendations) {
        var recommendationOptions = {
            appid: window.resx.appid,
            apiKey: CERTONA_API_KEY,
            event: window.resx.event,
            certonaSchema: getCertonaSchema(pipRecommendations),
            dynamicRecsSchema: getDynamicRecsSchema(pipRecommendations),
            customerid: window.resx.customerid,
            storeId: pip.customer.getStoreNumber(),
            products: window.resx.itemid,
            page: 'PIP'
        };

        recommendationOptions.version = 'pipmodel';

      if ((THD_GLOBAL.channel == 'mobile' && pip.features.mobileSponsoredComponentsEnabled == true) || (THD_GLOBAL.channel == 'web' && pip.features.desktopSponsoredComponentsEnabled == true)) {
        recommendationOptions.criteo = {
          key: SPONSORED_API_KEY,
          schema: schemas.sponsoredProducts
        };
      }

        if (BREADCRUMB_JSON && BREADCRUMB_JSON.bcEnsightenData && BREADCRUMB_JSON.bcEnsightenData.contentSubCategory) {
          recommendationOptions.promoteCategories = BREADCRUMB_JSON.bcEnsightenData.contentSubCategory.split('>').join(',');
        }

        if(certona.isFromSearchEngine() || certona.isFromProductListAd(pipRecommendations) || certona.isFromPinterest(pipRecommendations)) {
            recommendationOptions.seeAllLink = pip.products.primary.data.itemExtension.itemCategoryUrl;
        }

        recommendationOptions.itemid = recommendationOptions.products;

        if(shouldDisplayVisuallySimilar()){
          if(pip.platform.toLowerCase() === 'desktop') {
            var mediaList = pip.products.primary.data.media.mediaList,
                image;

            for (var key in mediaList) {
              if(mediaList[key].mediaType === 'IMAGE' && mediaList[key].height==='300'){
                image = mediaList[key].location;
              }
            }
          }
          recommendationOptions.visSim = {
            showATC : true,
            productImageURL : image ? image : ''
          };
          recommendations.refresh(recommendationOptions);
        } else {
          recommendations.refresh(recommendationOptions);
        }
        if (pip.features.recommendedGuidesFeatureEnabled) {
          articles.refresh(recommendationOptions);
        }


    }

    var certona =  {
        init: function init() {
          viewModel.pipRecommendations.itemType = pip.products.primary.data.info.isAppliance ? 'appliance' : 'merchandise';
          viewModel.pipRecommendations.platform = pip.platform === 'TABLET' ? 'desktop' : pip.platform.toLowerCase();
          viewModel.pipRecommendations.cm_mmcParam = thdUtils.getParametersByName('cm_mmc', window.location.href);
          viewModel.pipRecommendations.shouldCallReferrerRecs = false;
            pip.viewModel.certona = {
                isUnavailableScenario: isUnavailableScenario()
            };
            if(viewModel.pipRecommendations.platform !== 'desktop' && ! viewModel.pipRecommendations.shouldCallReferrerRecs) {
                $(document).one("scroll",function(){
                    refreshContent(viewModel.pipRecommendations);
                });
                if(shouldDisplayReferrerRecommendations(viewModel.pipRecommendations)) {
                  viewModel.pipRecommendations.shouldCallReferrerRecs = true;
                }
            }
            view.init(viewModel.pipRecommendations);
            updateResx();
            certonaResx.getURL();
            if(viewModel.pipRecommendations.platform === 'desktop' || viewModel.pipRecommendations.shouldCallReferrerRecs) {
                refreshContent(viewModel.pipRecommendations);
                viewModel.pipRecommendations.shouldCallReferrerRecs = false;
            }

        },
        isFromSearchEngine: isFromSearchEngine,
        isUnavailableScenario: isUnavailableScenario,
        isStoreOutOfStock: isStoreOutOfStock,
        isOnlineOutOfStock: isOnlineOutOfStock,
        isSharedOutOfStock: isSharedOutOfStock,
        isFromProductListAd: isFromProductListAd,
        isFromPinterest: isFromPinterest,
        getCertonaSchema: getCertonaSchema,
        getDynamicRecsSchema: getDynamicRecsSchema,
        shouldDisplayReferrerRecommendations: shouldDisplayReferrerRecommendations,
        shouldDisplayOutOfStockRecommendations: shouldDisplayOutOfStockRecommendations,
        shouldDisplayVisuallySimilar: shouldDisplayVisuallySimilar,
        outOfStockRecsThdSchemas: outOfStockRecsThdSchemas,
        view: view,
        viewModel: viewModel

    };

    return certona;
});

}.call(window));